import { jeepRallyApi } from "../api";

const rallyBaseUrl = "/api/v1/rally";
const routesBaseUrl = "/api/v1/routes";

export const getRouteByEventId = (eventId) => {
  return jeepRallyApi.get(`${rallyBaseUrl}/${eventId}/routes`);
};

export const getAllRoutes = () => {
  return jeepRallyApi.get(routesBaseUrl);
};

export const createRoute = (payload) => {
  if (payload instanceof FormData) {
    return jeepRallyApi.post(routesBaseUrl, payload, {
      headers: {
        "Content-Type": undefined,
      },
    });
  }

  // Backend expects JSON payload (see POST /api/v1/routes).
  return jeepRallyApi.post(routesBaseUrl, payload);
};

export const updateRoute = (routeId, payload) => {
  return jeepRallyApi.put(`${routesBaseUrl}/${routeId}`, payload);
};

export const deleteRoute = (routeId) => {
  return jeepRallyApi.delete(`${routesBaseUrl}/${routeId}`);
};
